module.exports = __webpack_public_path__ + "img/icon_egreso.034681f2.svg";